// extracted by mini-css-extract-plugin
export default {"select":"select_select__i0RM7","select--disabled":"select_select--disabled__Tu9j+"};